function guestId() {
  try {
    const key = "mars_guest";
    let id = sessionStorage.getItem(key) || "";
    if (!/^guest-[a-zA-Z0-9-]{8,48}$/.test(id)) {
      const rand = (window.crypto?.randomUUID?.() || Math.random().toString(16).slice(2) + Date.now().toString(16)).replace(/[^a-zA-Z0-9-]/g, "");
      id = `guest-${rand}`.slice(0, 48);
      sessionStorage.setItem(key, id);
    }
    return id;
  } catch {
    return "";
  }
}

export async function api(path, { method = "GET", body, token } = {}) {
  const guest = guestId();
  let response;
  try {
    response = await fetch(path, {
      method,
      credentials: "include",
      headers: {
        Accept: "application/json",
        ...(body ? { "Content-Type": "application/json" } : {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(guest ? { "X-Guest": guest } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw new Error("Sunucuya bağlanılamadı. Sayfayı yenileyip tekrar dene.");
  }

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.message || data.error || (typeof data === "string" ? data : "") || "İstek başarısız");
    error.status = response.status;
    error.code = data.code || "";
    if (data.payment) error.payment = data.payment;
    if (data.code === "SESSION_REPLACED" && typeof window !== "undefined") {
      localStorage.removeItem("bet_token");
      window.dispatchEvent(new CustomEvent("session-replaced", { detail: data.message }));
    }
    throw error;
  }
  return data;
}

export const authApi = {
  captcha: () => api("/api/auth/captcha"),
  login: (body) => api("/api/auth/login", { method: "POST", body }),
  login2fa: (body) => api("/api/auth/login/2fa", { method: "POST", body }),
  register: (body) => api("/api/auth/register", { method: "POST", body }),
  me: () => api("/api/auth/me"),
  logout: () => api("/api/auth/logout", { method: "POST" }),
  refresh: () => api("/api/auth/refresh", { method: "POST" }),
  updateProfile: (body) => api("/api/auth/profile", { method: "PUT", body }),
  updatePassword: (body) => api("/api/auth/password", { method: "PUT", body }),
  history: () => api("/api/auth/history"),
  setup2fa: () => api("/api/auth/2fa/setup", { method: "POST" }),
  enable2fa: (body) => api("/api/auth/2fa/enable", { method: "POST", body }),
  disable2fa: (body) => api("/api/auth/2fa/disable", { method: "POST", body }),
  setCurrency: (currency) => api("/api/auth/currency", { method: "PUT", body: { currency } }),
  savePrefs: (body) => api("/api/auth/prefs", { method: "PUT", body }),
  kyc: (body) => api("/api/auth/kyc", { method: "POST", body }),
  claimWelcome: () => api("/api/auth/bonus/welcome", { method: "POST", body: { bonus: "welcome" } }),
  claimWeekly: () => api("/api/auth/bonus/weekly", { method: "POST" }),
  claimBirthday: () => api("/api/auth/bonus/birthday", { method: "POST" }),
  claimLoss: (kind) => api("/api/auth/bonus/loss", { method: "POST", body: { kind } }),
  ranks: () => api("/api/auth/ranks"),
  avatar: (image) => api("/api/auth/avatar", { method: "POST", body: { image } }),
};

export const gamesApi = {
  list: (params = {}) => {
    const query = new URLSearchParams(
      Object.entries(params).filter(([, value]) => value !== undefined && value !== "")
    ).toString();
    return api(`/api/games${query ? `?${query}` : ""}`);
  },
  providers: (params = {}) => {
    const query = new URLSearchParams(
      Object.entries(params).filter(([, value]) => value !== undefined && value !== "")
    ).toString();
    return api(`/api/games/providers${query ? `?${query}` : ""}`);
  },
  one: (id) => api(`/api/games/meta/${encodeURIComponent(id)}`),
  launch: (body) => api("/api/games/launch", { method: "POST", body }),
};

export const paymentApi = {
  methods: () => api("/api/payments/methods"),
  rates: () => api("/api/payments/rates"),
  fx: () => api("/api/payments/fx"),
  list: () => api("/api/payments"),
  depositIban: (body) => api("/api/payments/deposit/iban", { method: "POST", body }),
  depositCrypto: (body) => api("/api/payments/deposit/crypto", { method: "POST", body }),
  cancel: (id, body) => api(`/api/payments/${id}/cancel`, { method: "POST", body }),
  receipt: (id, body) => api(`/api/payments/${id}/receipt`, { method: "POST", body }),
  openReceipt: async (id) => {
    const response = await fetch(`/api/payments/${id}/file`, { credentials: "include" });
    if (!response.ok) throw new Error("Dekont açılamadı");
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank", "noopener,noreferrer");
  },
  txid: (id, body) => api(`/api/payments/${id}/txid`, { method: "POST", body }),
  withdraw: (body) => api("/api/payments/withdraw", { method: "POST", body }),
  lookup: (q) => api(`/api/payments/lookup?q=${encodeURIComponent(q || "")}`),
  transfer: (body) => api("/api/payments/transfer", { method: "POST", body }),
};

export const supportApi = {
  thread: () => api("/api/support/thread"),
  live: () => api("/api/support/live", { method: "POST" }),
  open: (body) => api("/api/support/open", { method: "POST", body }),
  close: (kind = "live") => api("/api/support/close", { method: "POST", body: { kind } }),
  send: (body) => api("/api/support/message", { method: "POST", body }),
  inbox: () => api("/api/support/inbox"),
  readInbox: (id) => api(`/api/support/inbox/${id}/read`, { method: "POST" }),
  here: (path) => api("/api/support/here", { method: "POST", body: { path } }),
  typing: (text) => api("/api/support/typing", { method: "POST", body: { text } }),
  desk: () => api("/api/support/desk"),
  deskTyping: (body) => api("/api/support/desk/typing", { method: "POST", body }),
};

export const campaignApi = {
  vendors: () => api("/api/campaigns/vendors"),
  tiers: () => api("/api/campaigns/tiers"),
  limits: (params) => api(`/api/campaigns/vendors/limits?${new URLSearchParams(params || {})}`),
  list: () => api("/api/campaigns/list?active=1"),
  grant: (body) => api("/api/campaigns/grant", { method: "POST", body }),
  create: (body) => api("/api/campaigns/create", { method: "POST", body }),
  addPlayers: (code, players, extra = {}) => api(`/api/campaigns/${code}/players/add`, { method: "POST", body: { players, ...extra } }),
  cancel: (code) => api(`/api/campaigns/${code}/cancel`, { method: "POST" }),
};

export const originalsApi = {
  fair: () => api("/api/originals/fair"),
  setClientSeed: (clientSeed) => api("/api/originals/fair/client-seed", { method: "POST", body: { clientSeed } }),
  dice: (body) => api("/api/originals/dice", { method: "POST", body }),
  aviator: () => api("/api/originals/aviator"),
  aviatorPublic: () => api("/api/originals/aviator/public"),
  aviatorBet: (body) => api("/api/originals/aviator/bet", { method: "POST", body }),
  aviatorCashout: (body = {}) => api("/api/originals/aviator/cashout", { method: "POST", body }),
  minesState: () => api("/api/originals/mines"),
  minesStart: (body) => api("/api/originals/mines/start", { method: "POST", body }),
  minesReveal: (body) => api("/api/originals/mines/reveal", { method: "POST", body }),
  minesCashout: () => api("/api/originals/mines/cashout", { method: "POST" }),
  plinko: (body) => api("/api/originals/plinko", { method: "POST", body }),
  limbo: (body) => api("/api/originals/limbo", { method: "POST", body }),
  wheel: (body) => api("/api/originals/wheel", { method: "POST", body }),
  hiloStart: (body) => api("/api/originals/hilo/start", { method: "POST", body }),
  hiloGuess: (body) => api("/api/originals/hilo/guess", { method: "POST", body }),
  hiloCashout: () => api("/api/originals/hilo/cashout", { method: "POST" }),
  roulette: (body) => api("/api/originals/roulette", { method: "POST", body }),
  blackjackState: () => api("/api/originals/blackjack"),
  blackjackStart: (body) => api("/api/originals/blackjack/start", { method: "POST", body }),
  blackjackHit: () => api("/api/originals/blackjack/hit", { method: "POST", body: {} }),
  blackjackStand: () => api("/api/originals/blackjack/stand", { method: "POST", body: {} }),
  blackjackDouble: () => api("/api/originals/blackjack/double", { method: "POST", body: {} }),
  blackjackSplit: () => api("/api/originals/blackjack/split", { method: "POST", body: {} }),
};

export const winsApi = {
  list: () => api("/api/wins"),
};

export const sportsApi = {
  events: (cat = "all") => api(`/api/sports/events?cat=${encodeURIComponent(cat)}`),
  categories: () => api("/api/sports/categories"),
  bets: () => api("/api/sports/bets"),
  rules: () => api("/api/sports/rules"),
  bet: (body) => api("/api/sports/bet", { method: "POST", body }),
};

export const cryptoApi = {
  state: () => api("/api/crypto/state"),
  bets: () => api("/api/crypto/bets"),
  bet: (body) => api("/api/crypto/bet", { method: "POST", body }),
};

export const chatApi = {
  list: (after = 0) => api(`/api/chat?after=${Number(after) || 0}`),
  send: (text) => api("/api/chat", { method: "POST", body: { text } }),
  tip: (body) => api("/api/chat/tip", { method: "POST", body }),
  rain: (body) => api("/api/chat/rain", { method: "POST", body }),
  createCase: (body) => api("/api/chat/case", { method: "POST", body }),
  openCase: (id) => api(`/api/chat/case/${encodeURIComponent(id)}/open`, { method: "POST", body: {} }),
  presence: (active = true) => api("/api/chat/presence", { method: "POST", body: { active } }),
  remove: (id) => api(`/api/chat/${id}`, { method: "DELETE" }),
  nuke: () => api("/api/chat/nuke", { method: "POST", body: {} }),
  mute: (body) => api("/api/chat/mute", { method: "POST", body }),
};

export const adminApi = {
  overview: () => api("/api/admin/overview"),
  kasa: () => api("/api/admin/kasa"),
  users: () => api("/api/admin/users"),
  banUser: (id, banned) => api(`/api/admin/users/${id}/ban`, { method: "POST", body: { banned } }),
  deleteUser: (id) => api(`/api/admin/users/${id}/delete`, { method: "POST" }),
  setBalance: (id, body) => api(`/api/admin/users/${id}/balance`, { method: "POST", body }),
  addBalance: (id, body) => api(`/api/admin/users/${id}/balance`, { method: "POST", body }),
  updateUser: (id, body) => api(`/api/admin/users/${id}/profile`, { method: "POST", body }),
  inbox: () => api("/api/admin/inbox"),
  sendInbox: (body) => api("/api/admin/inbox", { method: "POST", body }),
  ips: () => api("/api/admin/ips"),
  banIp: (body) => api("/api/admin/ips", { method: "POST", body }),
  unbanIp: (ip) => api("/api/admin/ips", { method: "DELETE", body: { ip } }),
  payments: () => api("/api/admin/payments"),
  decide: (id, body) => api(`/api/admin/payments/${id}/decide`, { method: "POST", body }),
  payramSend: (id) => api(`/api/admin/payments/${id}/payram`, { method: "POST" }),
  recheck: (id) => api(`/api/admin/payments/${id}/recheck`, { method: "POST" }),
  support: () => api("/api/admin/support"),
  reply: (userId, text, threadId, image) => api(`/api/admin/support/${userId}`, { method: "POST", body: { text, threadId, image: image || undefined } }),
  claim: (userId, threadId) => api(`/api/admin/support/${userId}/claim`, { method: "POST", body: { threadId } }),
  release: (userId, threadId) => api(`/api/admin/support/${userId}/release`, { method: "POST", body: { threadId } }),
  assignIban: (userId) => api(`/api/admin/support/${userId}/iban`, { method: "POST" }),
  ticketStatus: (userId, status, threadId) => api(`/api/admin/support/${userId}/status`, { method: "POST", body: { status, threadId } }),
  supportNuke: () => api("/api/admin/support/nuke", { method: "POST", body: {} }),
  deleteSupportThread: (threadId) => api(`/api/admin/support/thread/${encodeURIComponent(threadId)}`, { method: "DELETE" }),
  purgePentest: () => api("/api/admin/maintenance/purge-pentest", { method: "POST", body: {} }),
  affiliate: () => api("/api/admin/affiliate"),
  grantAffiliate: (body) => api("/api/admin/affiliate", { method: "POST", body }),
  settings: () => api("/api/admin/settings"),
  saveSettings: (body) => api("/api/admin/settings", { method: "POST", body }),
};
